import classNames from "classnames";
import { ComponentProps, FunctionComponent } from "react";

interface IconButtonProps extends ComponentProps<"button"> {
  size?: string;
  variant?: 'ghost'
  // Icon-only control: require an accessible name.
  "aria-label": string;
}

const IconButton: FunctionComponent<IconButtonProps> = ({ className, children, size, variant, type = "button", ...props }) => {
  return (
    <button
      {...props}
      type={type}
      className={classNames(
        "rounded-full border hover:bg-theme-gray100 cursor-pointer flex items-center justify-center hover:text-theme-primary",
        "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-theme-primary",
        size,
        className,
        {
          "w-10 h-10": size == null,
          'border-0': variant === 'ghost',
          'hover:bg-transparent': variant === 'ghost',
        }
      )}
    >
      {children}
    </button>
  );
};

export default IconButton;
